import { render } from "./UpdatesIcon.vue?vue&type=template&id=76cc9daa"
import script from "./UpdatesIcon.vue?vue&type=script&lang=js"
export * from "./UpdatesIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__